import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { AngularSplitModule } from 'angular-split';
import { GitDiffTreeModule } from '../git-diff-tree';
import { GitStashedChangesDialogComponent } from './git-stashed-changes-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    FontAwesomeModule,
    AngularSplitModule,
    LogoLoaderModule,
    MonacoEditorModule,
    GitDiffTreeModule,
  ],
  declarations: [GitStashedChangesDialogComponent],
  exports: [GitStashedChangesDialogComponent],
})
export class GitStashedChangesDialogModule {}
